import React from 'react'

import { Helmet } from 'react-helmet'

import Menu from '../components/menu'
import './comunidad-enfocads.css'

const ComunidadEnfocads = (props) => {
  return (
    <div className="comunidad-enfocads-container">
      <Helmet>
        <title>Marchetti</title>
        <meta name="description" content="Marchetti" />
        <meta property="og:title" content="Marchetti" />
        <meta property="og:description" content="Marchetti" />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/cddaa0fe-329b-4980-ac51-175c84c5aca3/4e8ea9c2-19aa-4f93-a94f-0a54c9bae130?org_if_sml=1"
        />
      </Helmet>
      <Menu rootClassName="menu-root-class-name"></Menu>
      <div className="comunidad-enfocads-container01">
        <div className="comunidad-enfocads-container02">
          <img
            alt="image"
            src="/playground_assets/comunidad-%23mr-1500w.png"
            className="comunidad-enfocads-image"
          />
        </div>
        <div className="comunidad-enfocads-container03">
          <h1 className="comunidad-enfocads-text">de Enfocad@s</h1>
        </div>
      </div>
      <div className="comunidad-enfocads-hero">
        <div className="comunidad-enfocads-container04">
          <span className="comunidad-enfocads-text01">
            {' '}
            Es el espacio donde juntos evolucionemos el paradigma de la
            nutrición; un lugar en donde tu vínculo con la alimentación
            encuentre las herramientas para llevar a la acción ese cambio que
            buscás hace tanto tiempo. ⁣ Encontrarás herramientas para
            organizarte, participarás de las clases en vivo, beneficios
            exclusivos y mucho más!
          </span>
        </div>
        <div className="comunidad-enfocads-container05">
          <iframe
            src="https://www.youtube.com/embed/XPZFfIBfy6Q"
            className="comunidad-enfocads-iframe"
          ></iframe>
        </div>
      </div>
      <div className="comunidad-enfocads-beneficios">
        <h1 className="comunidad-enfocads-text02">BENEFICIOS DE LA</h1>
        <img
          alt="image"
          src="/playground_assets/comunidad-%23mr-1500w.png"
          className="comunidad-enfocads-image1"
        />
        <span className="comunidad-enfocads-text03">
          <span>
            Podes acceder al contenido desde cualquier parte del mundo y a
            través de cualquier dispositivo electrónico. Día a día tendrás a
            disposición está guía digital exclusivas para acompañarte a tomas
            mejores decisiones y que puedas ir forjando tu mejor versión.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
        </span>
        <div className="comunidad-enfocads-container06">
          <div className="comunidad-enfocads-container07">
            <img
              alt="image"
              src="/playground_assets/iconolecciones-300h.png"
              className="comunidad-enfocads-image2"
            />
            <span className="comunidad-enfocads-text05">
              Lecciones exclusivas de Nutrición y Coaching
            </span>
          </div>
          <div className="comunidad-enfocads-container08">
            <img
              alt="image"
              src="/playground_assets/iconobeneficios1-300h.png"
              className="comunidad-enfocads-image3"
            />
            <span className="comunidad-enfocads-text06">
              Beneficios Exclusivos
            </span>
          </div>
        </div>
        <div className="comunidad-enfocads-container09">
          <div className="comunidad-enfocads-container10">
            <img
              alt="image"
              src="/playground_assets/iconocampus-300h.png"
              className="comunidad-enfocads-image4"
            />
            <span className="comunidad-enfocads-text07">
              Campus #MarchettiRules®
            </span>
          </div>
          <div className="comunidad-enfocads-container11">
            <img
              alt="image"
              src="/playground_assets/iconoclases-300h.png"
              className="comunidad-enfocads-image5"
            />
            <span className="comunidad-enfocads-text08">
              Clases en Vivo.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
          </div>
        </div>
        <div className="comunidad-enfocads-container12">
          <div className="comunidad-enfocads-container13">
            <img
              alt="image"
              src="/playground_assets/iconoherramientas-400w.png"
              className="comunidad-enfocads-image6"
            />
            <span className="comunidad-enfocads-text09">
              Herramientas para poner en acción
            </span>
          </div>
          <div className="comunidad-enfocads-container14">
            <img
              alt="image"
              src="/playground_assets/iconofitness-300h.png"
              className="comunidad-enfocads-image7"
            />
            <span className="comunidad-enfocads-text10">Fitness</span>
          </div>
        </div>
      </div>
      <div className="comunidad-enfocads-pricing">
        <div className="comunidad-enfocads-container15">
          <div className="comunidad-enfocads-container16">
            <h1 className="comunidad-enfocads-text11">
              <span>Tipos de Suscripción</span>
              <br></br>
              <span>Argentina</span>
            </h1>
            <span className="comunidad-enfocads-text15">
              <span>
                <span>
                  Podes comenzar tu suscripción de manera mensual, trimestral o
                  semestral desde cualquier parte del mundo con tarjeta de
                  crédito/débito a través de Mercado Pago.
                </span>
              </span>
            </span>
          </div>
          <div className="comunidad-enfocads-container17">
            <a
              href="https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=2c938084826156040182739612f10790"
              target="_blank"
              rel="noreferrer noopener"
              className="comunidad-enfocads-link"
            >
              <div className="comunidad-enfocads-container18">
                <span className="comunidad-enfocads-text18">Mensual</span>
                <span className="comunidad-enfocads-text19">ARS 990</span>
                <button className="comunidad-enfocads-button button">
                  Suscribite Aquí
                </button>
              </div>
            </a>
            <a
              href="https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=2c9380848261560401827396b6580791"
              target="_blank"
              rel="noreferrer noopener"
              className="comunidad-enfocads-link01"
            >
              <div className="comunidad-enfocads-container19">
                <span className="comunidad-enfocads-text20">Trimestral</span>
                <span className="comunidad-enfocads-text21">ARS 2490</span>
                <button className="comunidad-enfocads-button1 button">
                  Suscribite Aquí
                </button>
              </div>
            </a>
            <a
              href="https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=2c938084825e8ae001827397a0eb08f7"
              target="_blank"
              rel="noreferrer noopener"
              className="comunidad-enfocads-link02"
            >
              <div className="comunidad-enfocads-container20">
                <span className="comunidad-enfocads-text22">Semestral</span>
                <span className="comunidad-enfocads-text23">ARS 4950</span>
                <button className="comunidad-enfocads-button2 button">
                  Suscribite Aquí
                </button>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="comunidad-enfocads-pricing1">
        <div className="comunidad-enfocads-container21">
          <div className="comunidad-enfocads-container22">
            <h1 className="comunidad-enfocads-text24">Resto del Mundo</h1>
            <span className="comunidad-enfocads-text25">
              <span>
                <span>
                  {' '}
                  Podes comenzar tu suscripción de manera mensual, trimestral o
                  semestral desde cualquier parte del mundo con tarjeta de
                  crédito/débito a través de Stripe.
                </span>
              </span>
            </span>
          </div>
          <div className="comunidad-enfocads-container23">
            <a
              href="https://buy.stripe.com/14k29l7q8fse8tq8wx"
              target="_blank"
              rel="noreferrer noopener"
              className="comunidad-enfocads-link03"
            >
              <div className="comunidad-enfocads-container24">
                <span className="comunidad-enfocads-text28">Mensual</span>
                <span className="comunidad-enfocads-text29">10 USD</span>
                <button className="comunidad-enfocads-button3 button">
                  Suscribite Aquí
                </button>
              </div>
            </a>
            <a
              href="https://buy.stripe.com/dR629lh0I6VI8tqbIK"
              target="_blank"
              rel="noreferrer noopener"
              className="comunidad-enfocads-link04"
            >
              <div className="comunidad-enfocads-container25">
                <span className="comunidad-enfocads-text30">Trimestral</span>
                <span className="comunidad-enfocads-text31">25 USD</span>
                <button className="comunidad-enfocads-button4 button">
                  Suscribite Aquí
                </button>
              </div>
            </a>
            <a
              href="https://buy.stripe.com/7sIeW739Scg2bFC5kn"
              target="_blank"
              rel="noreferrer noopener"
              className="comunidad-enfocads-link05"
            >
              <div className="comunidad-enfocads-container26">
                <span className="comunidad-enfocads-text32">Semestral</span>
                <span className="comunidad-enfocads-text33">50 USD</span>
                <button className="comunidad-enfocads-button5 button">
                  Suscribite Aquí
                </button>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="comunidad-enfocads-container27">
        <span className="comunidad-enfocads-text34">
          <span>
            IMPORTANTE:
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <span>
            UNA VEZ QUE TE SUSCRIBAS, TE ESTAREMOS CONTACTANDO EN 24/48HS PARA
            CONFIRMAR TU SUSCRIPCIÒN Y TUS DATOS.
          </span>
        </span>
      </div>
      <div className="comunidad-enfocads-container28">
        <span className="comunidad-enfocads-text37">
          <span className="comunidad-enfocads-text38">
            En cumplimiento con los reglamentos vigentes de protección de datos,
            los datos recabados durante la transacción serán respaldados por las
            pasarelas de pago y la marca, solo para verificación de compras y
            acciones de marketing para mejorar la experiencia del usuario. El
            continuar con la transacción es indicativo de aceptación de esto y
            de nuestra Politica de privacidad y Términos y condiciones
          </span>
        </span>
      </div>
      <footer className="comunidad-enfocads-footer">
        <div className="comunidad-enfocads-container29">
          <img
            alt="logo"
            src="/playground_assets/%23mr.svg"
            className="comunidad-enfocads-image8"
          />
        </div>
        <div className="comunidad-enfocads-container30">
          <span className="comunidad-enfocads-text39">
            © 2021 All Rights Reserved.
          </span>
        </div>
        <div className="comunidad-enfocads-icon-group">
          <a
            href="https://www.instagram.com/matias.marchetti/"
            target="_blank"
            rel="noreferrer noopener"
            className="comunidad-enfocads-link06"
          >
            <svg
              viewBox="0 0 877.7142857142857 1024"
              className="comunidad-enfocads-icon"
            >
              <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
            </svg>
          </a>
          <a
            href="https://www.facebook.com/LicMatiasMarchetti/"
            target="_blank"
            rel="noreferrer noopener"
            className="comunidad-enfocads-link07"
          >
            <svg
              viewBox="0 0 602.2582857142856 1024"
              className="comunidad-enfocads-icon02"
            >
              <path d="M548 6.857v150.857h-89.714c-70.286 0-83.429 33.714-83.429 82.286v108h167.429l-22.286 169.143h-145.143v433.714h-174.857v-433.714h-145.714v-169.143h145.714v-124.571c0-144.571 88.571-223.429 217.714-223.429 61.714 0 114.857 4.571 130.286 6.857z"></path>
            </svg>
          </a>
          <a
            href="https://ar.pinterest.com/MarchettiRules/"
            target="_blank"
            rel="noreferrer noopener"
            className="comunidad-enfocads-link08"
          >
            <svg
              viewBox="0 0 877.7142857142857 1024"
              className="comunidad-enfocads-icon04"
            >
              <path d="M877.714 512c0 242.286-196.571 438.857-438.857 438.857-43.429 0-84.571-6.286-124.571-18.286 16.571-26.286 35.429-60 44.571-93.714 0 0 5.143-19.429 30.857-120.571 14.857 29.143 59.429 54.857 106.857 54.857 141.143 0 237.143-128.571 237.143-301.143 0-129.714-110.286-251.429-278.286-251.429-208 0-313.143 149.714-313.143 274.286 0 75.429 28.571 142.857 89.714 168 9.714 4 18.857 0 21.714-11.429 2.286-7.429 6.857-26.857 9.143-34.857 2.857-11.429 1.714-14.857-6.286-24.571-17.714-21.143-29.143-48-29.143-86.286 0-110.857 82.857-210.286 216-210.286 117.714 0 182.857 72 182.857 168.571 0 126.286-56 233.143-139.429 233.143-45.714 0-80-37.714-69.143-84.571 13.143-55.429 38.857-115.429 38.857-155.429 0-36-19.429-66.286-59.429-66.286-46.857 0-84.571 48.571-84.571 113.714 0 0 0 41.714 14.286 69.714-48 203.429-56.571 238.857-56.571 238.857-8 33.143-8.571 70.286-7.429 101.143-154.857-68-262.857-222.286-262.857-402.286 0-242.286 196.571-438.857 438.857-438.857s438.857 196.571 438.857 438.857z"></path>
            </svg>
          </a>
          <a
            href="https://ar.linkedin.com/in/matias-marchetti"
            target="_blank"
            rel="noreferrer noopener"
            className="comunidad-enfocads-link09"
          >
            <svg
              viewBox="0 0 877.7142857142857 1024"
              className="comunidad-enfocads-icon06"
            >
              <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
            </svg>
          </a>
          <a
            href="https://twitter.com/marchettirules?lang=bg "
            target="_blank"
            rel="noreferrer noopener"
            className="comunidad-enfocads-link10"
          >
            <svg
              viewBox="0 0 950.8571428571428 1024"
              className="comunidad-enfocads-icon08"
            >
              <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
            </svg>
          </a>
          <a
            href="https://www.youtube.com/channel/UCLqCGfv-_ColrjRT9gqejdQ "
            target="_blank"
            rel="noreferrer noopener"
            className="comunidad-enfocads-link11"
          >
            <svg
              viewBox="0 0 877.7142857142857 1024"
              className="comunidad-enfocads-icon10"
            >
              <path d="M525.143 744.571v-89.714c0-18.857-5.714-28.571-16.571-28.571-6.286 0-12.571 2.857-18.857 9.143v128c6.286 6.286 12.571 9.143 18.857 9.143 10.857 0 16.571-9.143 16.571-28zM630.286 674.857h37.714v-19.429c0-19.429-6.286-29.143-18.857-29.143s-18.857 9.714-18.857 29.143v19.429zM304 522.857v40h-45.714v241.714h-42.286v-241.714h-44.571v-40h132.571zM418.857 594.857v209.714h-38.286v-22.857c-14.857 17.143-29.143 25.714-43.429 25.714-12 0-20.571-5.143-24-16-2.286-6.286-3.429-16-3.429-30.857v-165.714h37.714v154.286c0 8.571 0 13.714 0.571 14.857 0.571 5.714 3.429 8.571 8.571 8.571 8 0 15.429-5.714 24-17.714v-160h38.286zM562.857 658.286v83.429c0 18.857-1.143 33.143-4 41.714-4.571 16-14.857 24-30.286 24-13.143 0-26.286-8-38.857-23.429v20.571h-38.286v-281.714h38.286v92c12-14.857 25.143-22.857 38.857-22.857 15.429 0 25.714 8 30.286 24 2.857 8.571 4 22.286 4 42.286zM706.286 732v5.143c0 12.571-0.571 20.571-1.143 24.571-1.143 8.571-4 16-8.571 22.857-10.286 15.429-26.286 22.857-45.714 22.857-20 0-35.429-7.429-46.286-21.714-8-10.286-12-26.857-12-49.143v-73.714c0-22.286 3.429-38.286 11.429-49.143 10.857-14.286 26.286-21.714 45.714-21.714 18.857 0 34.286 7.429 44.571 21.714 8 10.857 12 26.857 12 49.143v43.429h-76v37.143c0 19.429 6.286 29.143 19.429 29.143 9.143 0 14.857-5.143 17.143-14.857 0-2.286 0.571-10.857 0.571-25.714h38.857zM448.571 261.143v89.143c0 19.429-6.286 29.143-18.286 29.143-12.571 0-18.286-9.714-18.286-29.143v-89.143c0-19.429 5.714-29.714 18.286-29.714 12 0 18.286 10.286 18.286 29.714zM753.143 668.571v0c0-49.143 0-101.143-10.857-148.571-8-33.714-35.429-58.286-68-61.714-77.714-8.571-156.571-8.571-235.429-8.571-78.286 0-157.143 0-234.857 8.571-33.143 3.429-60.571 28-68 61.714-10.857 47.429-11.429 99.429-11.429 148.571v0c0 48.571 0 100.571 11.429 148.571 7.429 33.143 34.857 57.714 67.429 61.714 78.286 8.571 157.143 8.571 235.429 8.571s157.143 0 235.429-8.571c32.571-4 60-28.571 67.429-61.714 11.429-48 11.429-100 11.429-148.571zM321.714 296.571l51.429-169.143h-42.857l-29.143 111.429-30.286-111.429h-44.571c8.571 26.286 18.286 52.571 26.857 78.857 13.714 40 22.286 69.714 26.286 90.286v114.857h42.286v-114.857zM486.857 342.857v-74.286c0-22.286-4-38.857-12-49.714-10.857-14.286-25.714-21.714-44.571-21.714-19.429 0-34.286 7.429-44.571 21.714-8 10.857-12 27.429-12 49.714v74.286c0 22.286 4 38.857 12 49.714 10.286 14.286 25.143 21.714 44.571 21.714 18.857 0 33.714-7.429 44.571-21.714 8-10.286 12-27.429 12-49.714zM590.286 411.429h38.286v-211.429h-38.286v161.714c-8.571 12-16.571 17.714-24 17.714-5.143 0-8.571-2.857-9.143-9.143-0.571-1.143-0.571-5.714-0.571-14.857v-155.429h-38.286v167.429c0 14.857 1.143 24.571 3.429 31.429 4 10.286 12.571 15.429 24.571 15.429 14.286 0 28.571-8.571 44-25.714v22.857zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
            </svg>
          </a>
          <a
            href="https://www.instagram.com/marchettirules/ "
            target="_blank"
            rel="noreferrer noopener"
            className="comunidad-enfocads-link12"
          >
            <svg viewBox="0 0 1024 1024" className="comunidad-enfocads-icon12">
              <path d="M512 92.2c136.8 0 153 0.6 206.8 3 50 2.2 77 10.6 95 17.6 23.8 9.2 41 20.4 58.8 38.2 18 18 29 35 38.4 58.8 7 18 15.4 45.2 17.6 95 2.4 54 3 70.2 3 206.8s-0.6 153-3 206.8c-2.2 50-10.6 77-17.6 95-9.2 23.8-20.4 41-38.2 58.8-18 18-35 29-58.8 38.4-18 7-45.2 15.4-95 17.6-54 2.4-70.2 3-206.8 3s-153-0.6-206.8-3c-50-2.2-77-10.6-95-17.6-23.8-9.2-41-20.4-58.8-38.2-18-18-29-35-38.4-58.8-7-18-15.4-45.2-17.6-95-2.4-54-3-70.2-3-206.8s0.6-153 3-206.8c2.2-50 10.6-77 17.6-95 9.2-23.8 20.4-41 38.2-58.8 18-18 35-29 58.8-38.4 18-7 45.2-15.4 95-17.6 53.8-2.4 70-3 206.8-3zM512 0c-139 0-156.4 0.6-211 3-54.4 2.4-91.8 11.2-124.2 23.8-33.8 13.2-62.4 30.6-90.8 59.2-28.6 28.4-46 57-59.2 90.6-12.6 32.6-21.4 69.8-23.8 124.2-2.4 54.8-3 72.2-3 211.2s0.6 156.4 3 211c2.4 54.4 11.2 91.8 23.8 124.2 13.2 33.8 30.6 62.4 59.2 90.8 28.4 28.4 57 46 90.6 59 32.6 12.6 69.8 21.4 124.2 23.8 54.6 2.4 72 3 211 3s156.4-0.6 211-3c54.4-2.4 91.8-11.2 124.2-23.8 33.6-13 62.2-30.6 90.6-59s46-57 59-90.6c12.6-32.6 21.4-69.8 23.8-124.2 2.4-54.6 3-72 3-211s-0.6-156.4-3-211c-2.4-54.4-11.2-91.8-23.8-124.2-12.6-34-30-62.6-58.6-91-28.4-28.4-57-46-90.6-59-32.6-12.6-69.8-21.4-124.2-23.8-54.8-2.6-72.2-3.2-211.2-3.2v0z"></path>
              <path d="M512 249c-145.2 0-263 117.8-263 263s117.8 263 263 263 263-117.8 263-263c0-145.2-117.8-263-263-263zM512 682.6c-94.2 0-170.6-76.4-170.6-170.6s76.4-170.6 170.6-170.6c94.2 0 170.6 76.4 170.6 170.6s-76.4 170.6-170.6 170.6z"></path>
              <path d="M846.8 238.6c0 33.91-27.49 61.4-61.4 61.4s-61.4-27.49-61.4-61.4c0-33.91 27.49-61.4 61.4-61.4s61.4 27.49 61.4 61.4z"></path>
            </svg>
          </a>
        </div>
      </footer>
    </div>
  )
}

export default ComunidadEnfocads
